export default __webpack_public_path__ + "static/media/addFiles.41b67c50.svg";